export default () => {
  if (window.jQuery) {
    window.jQuery(document).on('gform_post_render', (event, formId) => {
      const form = document.getElementById(`gform_${formId}`);

      if (!form) {
        return;
      }

      const requiredInputs = form.querySelectorAll('*[aria-required=true], .gfield_contains_required input[type="checkbox"]');

      requiredInputs.forEach(input => {
        input.required = true;
      });
    });
  }
};
